import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from 'react'

import ObjPushContactezNousQuestionFormation from './ObjPushContactezNousQuestionFormation'
import ObjPushComptoirDermatoEspaceFormation from './ObjPushComptoirDermatoEspaceFormation'

import '../../assets/css/0010_sections/0420_section_content_formation.css'
import '../../assets/css/0010_sections/0450_section_home_carrousel_tabs_formation.css'

class SectionPushContactEtDermato extends Component {
    constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const datasPage = this.props.sitecoreContext.route?.fields;
        return (
		<>
			{datasPage && 
				<section className="obj_section section_content_bottom_formation">
					<div className="ctn_section">

						<div className="ctn_row">

							<ObjPushContactezNousQuestionFormation datasPage={datasPage}/>

							<ObjPushComptoirDermatoEspaceFormation datasPage={datasPage}/>

						</div>

					</div>
				</section>
			}
		</>)
	}
}

export default withTranslation()(withSitecoreContext()(SectionPushContactEtDermato));